var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShareNewD = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#share-new-d_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#242427",
  d: "M40 79.535c21.832 0 39.53-17.697 39.53-39.529C79.53 18.174 61.831.476 40 .476 18.17.477.47 18.175.47 40.007c0 21.831 17.699 39.53 39.53 39.53Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__b)",
  d: "m40.646 30.386 5.457-5.457-5.64-5.64-6.654 6.653a14.264 14.264 0 0 0-3.144 4.741 14.42 14.42 0 0 1 9.981-.297Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__c)",
  d: "m61.22 18.797-.05-.049-5.642 5.642c.017.016.035.031.051.048a6.362 6.362 0 0 1 0 8.987l-7.143 7.143a6.362 6.362 0 0 1-8.986 0l-.05-.05-5.64 5.64.048.05a14.288 14.288 0 0 0 10.135 4.191c3.67 0 7.34-1.397 10.134-4.191l7.143-7.143c5.588-5.587 5.588-14.68 0-20.268Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__d)",
  d: "M49.335 49.352a14.38 14.38 0 0 1-5.392 1.047c-1.552 0-3.103-.25-4.589-.75l-5.947 5.948c-.281.28-.583.528-.9.745l5.685 5.684c.293-.249.578-.511.855-.788l7.144-7.144a14.245 14.245 0 0 0 3.144-4.742Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__e)",
  d: "m39.355 49.65-5.948 5.948a6.36 6.36 0 0 1-8.986 0 6.36 6.36 0 0 1 0-8.986l5.948-5.948 1.195-1.196a6.364 6.364 0 0 1 6.284-1.603 6.3 6.3 0 0 1 2.703 1.603 6.307 6.307 0 0 1 1.601 2.702 6.356 6.356 0 0 0 6.285-1.602l1.196-1.195a14.23 14.23 0 0 0-3.44-5.546 14.231 14.231 0 0 0-5.546-3.44 14.417 14.417 0 0 0-9.981.296 14.243 14.243 0 0 0-4.742 3.144l-7.144 7.144c-5.587 5.587-5.587 14.68 0 20.268a14.287 14.287 0 0 0 10.134 4.19c3.67 0 7.34-1.396 10.134-4.19l7.144-7.144a14.246 14.246 0 0 0 3.144-4.742 14.383 14.383 0 0 1-5.392 1.047c-1.552 0-3.103-.25-4.589-.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__f)",
  d: "M61.221 18.797c-5.587-5.587-14.68-5.587-20.267 0l-7.144 7.144a14.262 14.262 0 0 0-3.144 4.742 14.421 14.421 0 0 1 9.981-.297l5.947-5.948a6.335 6.335 0 0 1 4.494-1.858c1.627 0 3.254.62 4.493 1.858a6.362 6.362 0 0 1 0 8.987l-7.143 7.143a6.362 6.362 0 0 1-8.987 0 6.3 6.3 0 0 1-1.602-2.703h-.001a6.35 6.35 0 0 0-1.79-.256c-1.627 0-3.254.62-4.493 1.859l-1.196 1.196a14.242 14.242 0 0 0 3.441 5.544A14.288 14.288 0 0 0 43.945 50.4c3.669 0 7.34-1.397 10.133-4.192l7.143-7.143c5.589-5.587 5.589-14.68 0-20.268Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#share-new-d_svg__g)",
  strokeWidth: 1.882,
  d: "M37.848 37.865a6.364 6.364 0 0 0-1.79-.257c-1.627 0-3.255.62-4.494 1.86l-1.195 1.195-5.948 5.948a6.36 6.36 0 0 0 0 8.986 6.36 6.36 0 0 0 8.986 0l5.948-5.948c1.486.5 3.037.75 4.589.75 1.833 0 3.668-.349 5.392-1.047a14.246 14.246 0 0 1-3.144 4.742l-7.144 7.144a14.286 14.286 0 0 1-10.134 4.19c-3.67 0-7.34-1.396-10.134-4.19-5.587-5.588-5.587-14.68 0-20.268l7.144-7.144a14.241 14.241 0 0 1 4.742-3.144 14.417 14.417 0 0 1 9.98-.297"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__h)",
  d: "M34.121 37.911a6.384 6.384 0 0 1 3.727-.046 6.3 6.3 0 0 1 2.702 1.603 6.309 6.309 0 0 1 1.602 2.701 6.356 6.356 0 0 0 6.285-1.601l1.195-1.196a14.229 14.229 0 0 0-3.44-5.545 14.23 14.23 0 0 0-5.546-3.441 14.426 14.426 0 0 0-6.525-.619v8.144Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#share-new-d_svg__i)",
  strokeWidth: 1.882,
  d: "M30.588 30.606c.698-1.727 1.825-3.267 3.222-4.665l7.144-7.144c5.588-5.587 14.68-5.587 20.267 0 5.589 5.588 5.589 14.68 0 20.268l-7.143 7.143c-1.064 1.064-3.397 2.563-4.667 3.222m-.973-8.862 7.143-7.143a6.362 6.362 0 0 0 0-8.987 6.335 6.335 0 0 0-4.493-1.858c-1.627 0-3.255.62-4.494 1.858l-6.168 6.168"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__j)",
  d: "M44.75 42.373a6.346 6.346 0 0 1-6.903-4.508 6.348 6.348 0 0 0-1.79-.256c-1.628 0-3.255.62-4.494 1.859l-1.196 1.196a14.24 14.24 0 0 0 3.441 5.544 14.288 14.288 0 0 0 10.942 4.168v-8.003Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__k)",
  d: "M40.55 39.468a6.307 6.307 0 0 1 1.602 2.701 6.356 6.356 0 0 0 6.285-1.601l1.196-1.196a14.23 14.23 0 0 0-3.441-5.546l-.05-.049L40.5 39.42l.05.049Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__l)",
  stroke: "url(#share-new-d_svg__m)",
  strokeWidth: 1.882,
  d: "M29.758 22.481a2.76 2.76 0 0 0 1.49-3.607l-1.451-3.491A2.76 2.76 0 0 0 24.7 17.5l1.451 3.491a2.76 2.76 0 0 0 3.607 1.49Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__n)",
  stroke: "url(#share-new-d_svg__o)",
  strokeWidth: 1.882,
  d: "m20.956 26.201-3.495-1.443a2.76 2.76 0 0 0-2.106 5.102l3.494 1.442a2.76 2.76 0 0 0 2.107-5.1Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__p)",
  stroke: "url(#share-new-d_svg__q)",
  strokeWidth: 1.882,
  d: "M50.24 57.572a2.76 2.76 0 0 0-1.49 3.607l1.451 3.492a2.76 2.76 0 0 0 5.096-2.118l-1.45-3.491a2.76 2.76 0 0 0-3.608-1.49Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__r)",
  stroke: "url(#share-new-d_svg__s)",
  strokeWidth: 1.882,
  d: "M62.538 55.296a2.76 2.76 0 0 0 2.106-5.102l-3.495-1.442a2.76 2.76 0 1 0-2.106 5.1l3.495 1.444Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__t)",
  d: "M40 49.75c5.376 0 9.733-4.357 9.733-9.732 0-5.375-4.357-9.733-9.733-9.733-5.375 0-9.732 4.358-9.732 9.733 0 5.375 4.357 9.733 9.732 9.733Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__u)",
  d: "M30.42 41.743c.814 4.552 4.794 8.007 9.58 8.007 4.786 0 8.766-3.455 9.58-8.007H30.42Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__v)",
  d: "M45.413 40.736c-1.405.172-3.312.277-5.412.277-2.101 0-4.008-.105-5.413-.277a1.299 1.299 0 0 1-.997 1.075 6.657 6.657 0 0 0 12.82 0 1.298 1.298 0 0 1-.998-1.075Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__w)",
  d: "M40 43.224c2.251 0 4.322-.097 5.969-.26a6.6 6.6 0 0 0 .441-1.153 1.299 1.299 0 0 1-.997-1.075c-1.405.172-3.312.277-5.412.277-2.101 0-4.008-.105-5.413-.277a1.299 1.299 0 0 1-.997 1.075c.112.401.26.786.441 1.153 1.647.163 3.718.26 5.969.26Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__x)",
  stroke: "#F06727",
  strokeWidth: 0.941,
  d: "M40.001 41.483c1.925 0 3.694-.088 5.074-.235.154.355.42.65.755.838a6.186 6.186 0 0 1-11.658 0c.335-.188.602-.483.756-.838 1.38.147 3.149.235 5.073.235Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__y)",
  d: "M37.037 40.938c.058 2.021.305 3.862.682 5.333a6.64 6.64 0 0 0 2.28.401c.801 0 1.569-.142 2.28-.401.378-1.47.624-3.312.682-5.333a57.51 57.51 0 0 1-2.962.074c-1.048 0-2.048-.026-2.962-.074Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__z)",
  d: "M37.037 40.938c.058 2.021.305 3.862.682 5.333a6.64 6.64 0 0 0 2.28.401c.801 0 1.569-.142 2.28-.401.378-1.47.624-3.312.682-5.333a57.51 57.51 0 0 1-2.962.074c-1.048 0-2.048-.026-2.962-.074Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__A)",
  d: "M46.41 41.811a1.299 1.299 0 0 1-.997-1.075c-1.405.172-3.312.277-5.413.277v5.66a6.657 6.657 0 0 0 6.41-4.862Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__B)",
  d: "M36.239 38.923a1.234 1.234 0 0 1-1.234-1.234v-.633a1.234 1.234 0 0 1 2.468 0v.633c0 .681-.553 1.234-1.234 1.234Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__C)",
  d: "M43.767 38.923a1.234 1.234 0 0 1-1.234-1.234v-.633a1.234 1.234 0 0 1 2.468 0v.633c0 .681-.552 1.234-1.234 1.234Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__D)",
  d: "M46.614 42.192a1.546 1.546 0 1 0 0-3.092 1.546 1.546 0 0 0 0 3.092Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#share-new-d_svg__E)",
  d: "M33.383 42.192a1.546 1.546 0 1 0 0-3.092 1.546 1.546 0 0 0 0 3.092Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__b",
  x1: 39.012,
  x2: 36.222,
  y1: 25.442,
  y2: 35.939,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__c",
  x1: 53.195,
  x2: 59.84,
  y1: 38.183,
  y2: 44.829,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__d",
  x1: 40.391,
  x2: 42.583,
  y1: 54.559,
  y2: 47.484,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__e",
  x1: 21.813,
  x2: 36.905,
  y1: 29.637,
  y2: 60.532,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__f",
  x1: 37.592,
  x2: 52.685,
  y1: 14.606,
  y2: 45.502,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4FE3AD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.716,
  stopColor: "#4E72DF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__g",
  x1: 20.76,
  x2: 40.035,
  y1: 33.709,
  y2: 60.681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__h",
  x1: 40.593,
  x2: 47.303,
  y1: 35.911,
  y2: 49.397,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__i",
  x1: 36.772,
  x2: 55.338,
  y1: 18.569,
  y2: 45.333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__j",
  x1: 38.531,
  x2: 32.684,
  y1: 43.735,
  y2: 30.979,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__k",
  x1: 45.51,
  x2: 46.86,
  y1: 40.383,
  y2: 43.557,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#5548F3",
  stopOpacity: 0.288
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.774,
  stopColor: "#5548F3",
  stopOpacity: 0.774
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__l",
  x1: 25.726,
  x2: 30.825,
  y1: 14.707,
  y2: 20.393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__m",
  x1: 25.726,
  x2: 30.825,
  y1: 14.707,
  y2: 20.393,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52CFBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B57D2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__n",
  x1: 15.248,
  x2: 18.548,
  y1: 25.341,
  y2: 31.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__o",
  x1: 15.248,
  x2: 18.548,
  y1: 25.341,
  y2: 31.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52CFBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B57D2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__p",
  x1: 49.776,
  x2: 54.875,
  y1: 58.386,
  y2: 64.072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__q",
  x1: 49.776,
  x2: 54.875,
  y1: 58.386,
  y2: 64.072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52CFBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B57D2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__r",
  x1: 58.937,
  x2: 62.237,
  y1: 49.334,
  y2: 55.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3EEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9EF3F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__s",
  x1: 58.937,
  x2: 62.237,
  y1: 49.334,
  y2: 55.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52CFBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B57D2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__t",
  x1: 37.993,
  x2: 47.648,
  y1: 38.011,
  y2: 47.666,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F173"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBB03B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__u",
  x1: 40,
  x2: 40,
  y1: 42.957,
  y2: 49.98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DB841D",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F15A24"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__v",
  x1: 38.255,
  x2: 44.136,
  y1: 40.63,
  y2: 46.512,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3DAFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__w",
  x1: 39.824,
  x2: 40.664,
  y1: 41.175,
  y2: 44.203,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3DAFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__x",
  x1: 38.255,
  x2: 44.137,
  y1: 40.63,
  y2: 46.512,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAF6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3DAFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__y",
  x1: 39.667,
  x2: 31.194,
  y1: 43.596,
  y2: 51.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8AC9FE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#75AACE",
  stopOpacity: 0.411
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#537983"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__z",
  x1: 41.052,
  x2: 48.227,
  y1: 43.815,
  y2: 45.838,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8AC9FE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#75AACE",
  stopOpacity: 0.411
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#537983"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__A",
  x1: 41.808,
  x2: 33.678,
  y1: 43.332,
  y2: 47.416,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8AC9FE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#75AACE",
  stopOpacity: 0.411
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#537983"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__B",
  x1: 36.239,
  x2: 36.239,
  y1: 35.822,
  y2: 38.923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5E5E60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E3E42"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__C",
  x1: 43.767,
  x2: 43.767,
  y1: 35.822,
  y2: 38.923,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5E5E60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E3E42"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__D",
  x1: 45.494,
  x2: 48.425,
  y1: 39.526,
  y2: 42.457,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F173"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBB03B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "share-new-d_svg__E",
  x1: 32.511,
  x2: 36.299,
  y1: 39.773,
  y2: 43.562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F173"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBB03B"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "share-new-d_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v80H0z"
})))));
export { SvgShareNewD as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDQxNTYyNjZlMWYyM2JhNmE4M2ViOTNhYzdlZTczNmUuc3ZnIjs=";